import React, {Component} from 'react';
import {Api} from '../../api';
import SelectInput from '../../components/Common/SelectInput'
import {getAuthToken} from '../../utils';
import {connect} from 'react-redux';
import './ConfirmCompanies.scss';
import TextFieldInput from "../../components/Common/TextFieldInput";
import ButtonInput from "../../components/Common/ButtonInput";


class ConfirmCompanies extends Component {

    state = {
        countries: [],
        country: '',
        countryId: null,
        providerId: null,
        providers: [],
        provider: '',
        companyTypeList: [],
        companyType: '',
        jurisdictionOfIncorporations: [],
        personalData: {
            companyType: '',
            firstName: '',
            id: '',
            jurisdiction: '',
            lastName: '',
            taxIDNumber: '',
        },
        confirmed: false,
        isOpenModal: false,
        OSName: null,
        isLoading: true,
    };

    // https://blockchain.info/rawtx/db8c91ad78f6905d562db9ba460c70379e6b47b395728d9b66a822a56088942f
    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate() {
    }

    componentWillMount() {
        this.props.handleLoader(true);
    }

    componentDidMount() {
        const authToken = getAuthToken();

        console.log('I\'m in the confir companies screen');
        Api.get(`company`, authToken)
            .then((response) => {
                console.log('I\'m get confirm companies response');;
                let allConfirmed = true;
                let notConfirmedCompany = {};
                for (const company of response.data) {
                    if (!company.confirmed) {
                        allConfirmed = false;
                        notConfirmedCompany = company;
                        break;
                    }
                }

                if (allConfirmed) {
                    console.log('Redirect to payment');
                    this.props.history.push('/user/personal-data/wait-for-payment');
                    return;
                    // return <Redirect to={`/user/personal-data/wait-for-payment`} />
                }


                console.log(response, 'response companies personal data');

                let companyTypeList = notConfirmedCompany.companyTypeList.map((companyType, index) => ({
                    id: index,
                    title: companyType,
                }));

                this.setState({
                    personalData: notConfirmedCompany,
                    companyTypeList: companyTypeList,
                    isLoading: false,
                });
                setTimeout(() => this.props.handleLoader(false), 200)
            }).catch((error) => {
                console.log('Error get companies');
                console.log(error);
                // setTimeout(() => this.props.handleLoader(false), 200)
            });

    }

    render() {
        const {isLoading, companyTypeList, personalData} = this.state;

        return (!isLoading &&
            <div className="content">
                <div className="content-h2">Your digital signature</div>
                <div className="hr-content"/>
                <div className="content-body">
                    <div className="fields-row">
                        <TextFieldInput name='firstName'
                                        id={'firstName'}
                                        label='First Name'
                                        disabled={true}
                                        required={true}
                                        value={personalData.firstName}
                                        classes='width-328'
                                        handleChange={(e) => this.handleChange(e)}/>
                    </div>
                    <div className="fields-row">
                        <TextFieldInput name='lastName'
                                        id={'lastName'}
                                        label='Last Name'
                                        disabled={true}
                                        required={true}
                                        value={personalData.lastName}
                                        classes='width-328'
                                        handleChange={(e) => this.handleChange(e)}/>
                    </div>
                    <div className="fields-row">
                        <SelectInput name='companyType'
                                     id='companyType'
                                     label='Company type'
                                     value={personalData.companyType}
                                     disabled={true}
                                     required={true}
                                     classes='width-328'
                                     options={companyTypeList}
                                     handleChange={(e) => this.handleChange(e)}/>
                    </div>
                    <div className="fields-row">
                        <TextFieldInput name='jurisdictionOfIncorporation'
                                        id={'jurisdictionOfIncorporation'}
                                        label='Jurisdiction of incorporation'
                                        disabled={true}
                                        required={true}
                                        value={personalData.jurisdiction}
                                        classes='width-328'
                                        handleChange={(e) => this.handleChange(e)}/>
                    </div>
                    <div className="fields-row">
                        <TextFieldInput name='taxIDNumber'
                                        id={'taxIDNumber'}
                                        label='Tax ID number'
                                        disabled={true}
                                        required={true}
                                        value={personalData.taxIDNumber}
                                        classes='width-328'
                                        handleChange={(e) => this.handleChange(e)}/>
                    </div>
                    <div className="fields-row">
                        <div className="confirm-text">Please confirm the information. <br/>
                            You can change any field if it is wrong
                        </div>
                    </div>
                    <div className="fields-row">
                        <ButtonInput
                            width='328'
                            className={`dark-button `}
                            title='Confirm'
                            handleClick={(e) => this.onSubmitPersonalData(e)}/>
                    </div>
                </div>
            </div>
        )
    }

    onSubmitPersonalData = (e) => {
        e.preventDefault();
        this.props.handleLoader(true);
        const {personalData} = this.state;
        const authToken = getAuthToken();

        Api.post(`company/${personalData.id}/confirm`, {}, authToken).then((response) => {

            this.setState({confirmed: true});
            console.log(response, 'response');
            this.componentDidMount();
            setTimeout(() => this.props.handleLoader(false), 200)

        }).catch((error) => {
            console.log(error, 'error')
        })
    };

    handleChange = event => {
        const {errors, countries, providers} = this.state;
        console.log(event.target.name, 'event.target.name', event.target.value);

        this.setState({
            [event.target.name]: event.target.value,
        });

        if (event.target.name === 'provider') {
            const providerId = providers.map((provider, index) => {
                if (provider.title === event.target.value) return provider.id;
            });

            this.setState({providerId});
        }

        if (event.target.name === 'country') {
            this.props.handleLoader(true);
            const authToken = getAuthToken();

            let countryId = null;

            countries.map((country, index) => {
                if (country.title === event.target.value) countryId = country.id;
            });

            Api.get(`applet/providers?country=${countryId}`, authToken)
                .then((response) => {

                    let providers = response.data.map((provider, index) => ({
                        id: provider.id,
                        value: provider.id,
                        title: provider.providerName,
                    }));

                    this.setState({providers, countryId});

                    setTimeout(() => this.props.handleLoader(false), 200)
                }).catch((error) => {
                setTimeout(() => this.props.handleLoader(false), 200)
            });
        }
    };
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(ConfirmCompanies);


// WEBPACK FOOTER //
// ./src/views/ConfirmCompanies/ConfirmCompanies.js